import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import NumberFormat from 'react-number-format';

export default class SystemModulePrices extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true
        };
    }
    componentDidMount() {
        this.httpPost("api/v1/systemmoduleprice/get", {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/systemmoduleprice/save", {
            records: this.state.data.records
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setValue(id, f, e) {
        this.state.data.records.forEach(item => {
            if (item.id === id) item[f] = e;
        });
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block nk-block-lg">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <div className="card-head">
                                            <h5 className="card-title">تنظیمات</h5>
                                        </div>
                                        <ul className="nav nav-tabs mt-n3">
                                            <li className="nav-item">
                                                <a className="nav-link active" data-bs-toggle="tab" href="#pricing"><em className="icon ni ni-info"></em><span>قیمت گذاری ماژول ها</span></a>
                                            </li>
                                        </ul>
                                        <div className="tab-content">
                                            <div className="tab-pane active" id="pricing">
                                                <form method="post" onSubmit={e => this.save(e)} className="row g-4">
                                                    <table className="table table-ulogs invoceEntryTable">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th className="text-center">عنوان ماژول</th>
                                                                <th style={{ "width": "60px" }} className="text-center">کد ماژول</th>
                                                                <th style={{ "width": "85px" }} className="text-center">قیمت پایه</th>
                                                                <th style={{ "width": "110px" }} className="text-center">قیمت ضریب مازاد</th>
                                                                <th style={{ "width": "85px" }} className="text-center">درصد تمدید</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.data.records.map(record =>
                                                                <tr key={record.id}>
                                                                    <td><input style={{ "width": "100%" }} className="form-control" type="text" defaultValue={record.title} disabled={true} /></td>
                                                                    <td><input style={{ "width": "60px" }} className="form-control" type="text" defaultValue={record.id} disabled={true} /></td>
                                                                    <td><NumberFormat style={{ "width": "85px" }} defaultValue={record.basePrice} onChange={e => this.setValue(record.id, 'basePrice', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control' /></td>
                                                                    <td><NumberFormat style={{ "width": "110px" }} defaultValue={record.exPrice} onChange={e => this.setValue(record.id, 'exPrice', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control' /></td>
                                                                    <td><NumberFormat style={{ "width": "85px" }} defaultValue={record.renewalPercent} onChange={e => this.setValue(record.id, 'renewalPercent', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control' /></td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <button type="submit" className="btn btn-lg btn-primary">ذخیره</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}